module.exports = __webpack_public_path__ + "static/media/SANTA_RELIQUIA_ORIGINAL_small.aaffcbdd.jpg";